export default "\n\n    <router-outlet #outlet=\"outlet\" ></router-outlet>\n\n\n\n";